module.exports = __webpack_public_path__ + "static/media/desert.7f18e55e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/desert.jpg
// module id = 34
// module chunks = 0